import { GetAllFunds } from '../../common/api/FundAPIHelper';
import { GetAllInvestments } from '../../common/api/InvestmentAPIHelper';

export const fetchFunds = async () => {
  try {
    const funds = await GetAllFunds();
    const investments = await GetAllInvestments();
    console.log(funds);
    console.log(investments);

    const fundsData = JSON.parse(funds.body);
    const investmentsData = investments;

    const transformedData = fundsData.map(item => {
      let totalInvestments = 0;
      investmentsData.forEach(investment => {
        if (investment.internal_fund_id === item.internal_fund_id) {
          totalInvestments += investment.investment_amount;
        }
      });

      return {
        internal_fund_id: item.internal_fund_id,
        fund_name: item.fund_name,
        target_aum: item.target_aum,
        current_aum: item.current_aum,
        fund_lp_portal: item.fund_lp_portal,
        total_investments_in_fund: totalInvestments,
        available_dry_powder: item.current_aum - totalInvestments
      };
    });

    return transformedData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
